import { styles as LS } from "components/Tools/LibraryModal/styles/LibraryModal.styles"
import { styles as WSS } from "pages/student/games/WordSearch/styles/WordSearchSettings.styles"
import { modalContent } from "themes/default/mixins"
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const ITEM_BORDER_RADIUS = 4

export const styles = {
  contanier: (theme) => ({
    ...modalContent,
    overflow: "visible",
    p: 0,
    m: 0,
    minHeight: 0,
    backgroundColor: theme.palette.background.default,
  }),
  mainImage: {
    ...LS.mainImage,
  },
  optionsContainer: (theme) => ({
    // backgroundColor: "#fff9eb",
    backgroundColor: theme.palette.background.default,
    padding: "30px",
    borderRadius: 2,
  }),
  closeButton: {
    position: "absolute",
    top: 10,
    left: 10,
  },
  select: (theme) => ({
    "& .MuiOutlinedInput-notchedOutline": {
      border: `none!important`,
      borderRadius: ITEM_BORDER_RADIUS,
      textTransform: "capitalize",
    },
    "& .MuiSelect-select": {
      backgroundColor: theme.palette.yellow.main,
      border: `1px solid ${theme.palette.yellow.main}`,
      borderRadius: ITEM_BORDER_RADIUS,
      textTransform: "capitalize",
      color: theme.palette.common.white,
      textAlign: "center",
      fontSize: theme.typography.span.fontSize,
      pt: 2,
      pb: 1,
    },
  }),
  selectEmpty: (theme) => ({
    "& .MuiSelect-select": {
      backgroundColor: theme.palette.grey.lighter1,
      border: `1px solid ${theme.palette.grey.lighter1}`,
      color: theme.palette.common.black,
    },
  }),
  selectInput: {
    "&:focus": {
      borderRadius: ITEM_BORDER_RADIUS,
    },
  },
  selectMenu: (theme) => ({
    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    backgroundColor: theme.palette.yellow.main,
    border: `1px solid ${theme.palette.yellow.main}`,
    color: theme.palette.common.white,
    borderRadius: ITEM_BORDER_RADIUS,
  }),
  selectMenuEmpty: (theme) => ({
    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    backgroundColor: theme.palette.grey.lighter1,
    border: `1px solid ${theme.palette.grey.lighter1}`,
    color: theme.palette.common.black,
    borderRadius: ITEM_BORDER_RADIUS,
  }),
  selectMenuItem: (theme) => ({
    textTransform: "capitalize",
    fontSize: theme.typography.span.fontSize,
    "&:hover": {
      backgroundColor: `rgba(0, 0, 0, 0.1)`,
    },
    "&.Mui-selected": {
      backgroundColor: `rgba(0, 0, 0, 0.1)`,
    },
  }),
  title: WSS.title,
  optionsContent: WSS.optionsContent,
}
